import React from "react";
import { Volume2, Loader2 } from "lucide-react";
import { useAudio } from "./AudioProvider";

// Round blue "?" / speaker button that reads the given text aloud.
export function SpeakerButton({ text, speed = 1.0, tag = "help", className = "", label, testId = "read-aloud-help-button" }) {
  const { speak, speaking, loadingKey } = useAudio();
  const isLoading = loadingKey === tag;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => speak(text, speed, tag)}
      className={`yb-tactile yb-focus inline-flex items-center gap-2 bg-[#2563EB] text-white font-bold px-4 py-3 min-h-[56px] hover:bg-[#1D4ED8] ${className}`}
    >
      {isLoading ? <Loader2 className="w-6 h-6 animate-spin" /> : <Volume2 className="w-6 h-6" />}
      {label && <span className="text-base">{label}</span>}
      {speaking && !isLoading && (
        <span className="yb-wave flex items-end h-5" aria-hidden>
          <span></span><span></span><span></span><span></span>
        </span>
      )}
    </button>
  );
}
